module.exports = __webpack_public_path__ + "static/APIEnv-9dfc1690e48b8070f845d0474315b3a1.png";